import React from 'react';
import FallbackPage from './FallbackPage.js';

const FallbackPageComponent = () => <FallbackPage />;

export const FallbackPageExample = {
  component: FallbackPageComponent,
  props: {},
  group: 'PageBuilder',
  rawOnly: true,
};
